import { render } from "./previewModel.vue?vue&type=template&id=063da298"
import script from "./previewModel.vue?vue&type=script&lang=js"
export * from "./previewModel.vue?vue&type=script&lang=js"

import "./previewModel.vue?vue&type=style&index=0&id=063da298&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__